import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const ProgramCard = ({ 
  icon, 
  title, 
  description, 
  iconBgColor = 'bg-yellow-500',
  className = '' 
}) => {
  return (
    <div className={`bg-white/10 backdrop-blur-sm rounded-lg p-4 flex items-center program-card ${className}`}>
      <div className={`w-12 h-12 ${iconBgColor} rounded-lg flex items-center justify-center mr-4`}>
        <FontAwesomeIcon icon={icon} className="text-white text-xl" />
      </div>
      <div>
        <h4 className="text-white font-bold">{title}</h4>
        <p className="text-gray-200 text-sm">{description}</p>
      </div>
    </div>
  );
};

export default ProgramCard;
